<template>
  <!-- View Legal basis modal template -->
  <b-modal ref="view-io" hide-footer @hide="hidePolicyModal" v-if="object">
    <div class="d-block text-center">
      <h4 qid="update-tp-title">
        {{ $t('processes.policies.view.title') }}
      </h4>
      <div v-if="object.policy" class="small">
          <span v-if="object.policy.validation && object.policy.validation.validation === 1"
                qid="policy-validation-approved"
          >
            <span >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
            </span>
            {{ $t('system.approved') }}
          </span>
          <span v-if="object.policy.validation && object.policy.validation.validation === 0"
                qid="policy-validation-rejected"
          >
            <span >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
            </span>
            {{ $t('system.rejected') }}
          </span>
          <span v-if="object.policy.validation" class="text-muted font-italic">
            {{ $t('system.by') }}
            <span v-if="object.policy.validation.created_by" qid="view-policy-validation-by">
              {{ object.policy.validation.created_by.name }}
            </span>
          </span>
          <span v-if="object.policy.validation" class="text-muted font-italic">
            {{ $t('system.on') }}
            <span v-if="object.policy.validation.created_at" qid="view-policy-validation-date">
              {{ object.policy.validation.created_at | formatDate }}
            </span>
          </span>
      </div>
    </div>

    <label class="mt-3">
      {{ $t('processes.policies.view.name') }}
    </label>
    <br>
    <span v-if="object.policy" qid="policy-name">
      {{ object.policy.name }}
    </span>
    <br>

    <label class="mt-3" v-if="object.policy && object.policy.description">
      {{ $t('processes.policies.create.policy_description_label') }}
    </label>
    <br>
    <span v-if="object.policy && object.policy.description"
          class="text-formatted"
          qid="policy-description"
    >
      {{ object.policy.description }}
    </span>
    <br>

    <label class="mt-3" v-if="object.policy && object.policy.implementation_status">
      {{ $t('maintenance.policies.create.implementation_status_label') }}
    </label>
    <br>
    <span v-if="object.policy && object.policy.implementation_status" qid="policy-implementation-status">
      {{ object.policy.implementation_status }}
    </span>
    <br>

    <label class="mt-3" v-if="object.policy && object.policy.category">
      {{ $t('maintenance.policies.create.category_label') }}
    </label>
    <br>
    <span v-if="object.policy && object.policy.category" qid="policy-category">
      {{ $t('maintenance.policies.category.' + $options.filters.slugify(object.policy.category)) }}
    </span>
    <br>

    <div class="mt-3" v-if="object.policy && object.policy.media && object.policy.media.length">
      <p class="text-dark">{{ $t('attachments.label') }}</p>
      <p v-for="(file, index) in object.policy.media">
        <span class="mr-3 float-right text-muted cursor-pointer"
              @click="downloadMedia(file)"
              qid="download-media"
        >
          <font-awesome-icon icon="cloud-download-alt" />
        </span>
        <a @click="downloadMedia(file)" qid="create-tp-media-item">
          {{ file.file_name }}
        </a>
      </p>
      <br>
    </div>
    <div v-if="object.policy && object.policy.links && object.policy.links.length">
      <p class="text-dark">{{ $t('links.label') }}</p>
      <div v-if="object.policy.links">
        <p v-for="(link, index) in object.policy.links" >
          <a :href="link.url" target="_blank" qid="create-tp-link-item">
            {{ link.name ? link.name : link.url }}
          </a>
        </p>
      </div>
      <br>
    </div>

    <b-button class="mt-4 float-right"
              variant="success"
              @click="hidePolicyModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.policies.view.close') }}
    </b-button>
    <br>

  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'PolicyViewModal',
    data: function() {
      return {
        error: '',
        processGroup: [],
        showInput: false,
        loadingItems: false,
        showArticleDescription: false
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getMedia() {
        return this.object.media
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showPolicyModal()
        }
      }
    },
    methods: {
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      showPolicyModal() {
        let self = this
        this.$refs['view-io'].show()
      },
      hidePolicyModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.$emit('closeViewModal');
        this.$refs['view-io'].hide()
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
